<div class="modal-container">
  <div class="modal-header">
    <h2 mat-dialog-title class="dialog-title">
      <mat-icon>label</mat-icon>
      <span>Alterar tags</span>
    </h2>
    <button mat-icon-button (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <!-- Operação -->
    <p class="question-label">O que deseja fazer com os produtos selecionados?</p>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Ação</mat-label>
      <mat-select [(ngModel)]="modo" (ngModelChange)="onModoChange()">
        <mat-option value="incluir">Incluir tags</mat-option>
        <mat-option value="excluir">Excluir tags</mat-option>
      </mat-select>
    </mat-form-field>
    <p class="help-text">{{ helpText }}</p>

    <!-- Tags -->
    <div class="tags-header">
      <span class="tags-label">Selecione as tags</span>
      @if (tagsSelecionadas.size > 0) {
        <span class="status-badge badge-vermelho">
          {{ contadorText }}
        </span>
      }
    </div>

    <!-- Busca -->
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Buscar tags...</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [(ngModel)]="searchText" (ngModelChange)="filtrarTags()" />
    </mat-form-field>

    <!-- Lista de Tags -->
    <div class="tag-list">
      @for (tag of tagsFiltradas; track tag.idTag) {
        <div class="tag-item" (click)="toggleTag(tag.idTag)">
          <mat-checkbox
            [checked]="isTagSelecionada(tag.idTag)"
            (click)="$event.stopPropagation()"
            (change)="toggleTag(tag.idTag)">
            <span class="tag-label">
              <span class="tag-cor" [style.background-color]="tag.cor"></span>
              {{ tag.nome }}
            </span>
          </mat-checkbox>
        </div>
      }

      @if (tagsFiltradas.length === 0) {
        <p class="empty-tags">Nenhuma tag encontrada.</p>
      }
    </div>
  </div>

  <div mat-dialog-actions align="end" class="mat-mdc-dialog-actions">
    <button mat-stroked-button class="btn-secondary" (click)="fechar()">Cancelar</button>
    <button mat-flat-button class="btn-primary" [disabled]="!podeAplicar" (click)="salvar()">
      @if (isLoading) {
        <mat-spinner diameter="20"></mat-spinner>
      }
      @if (!isLoading) {
        <span>Aplicar</span>
      }
    </button>
  </div>
</div>
